import { styled, TextArea as TamaguiTextArea } from 'tamagui';

/**
 * Styled TextArea component following the same pattern as StyledInput
 *
 * Key features:
 * - No border on focus (prevents border showing when selected)
 * - Uses tertiary50 background color by default
 * - Consistent padding and font size
 * - Placeholder color from design tokens
 * - Multi-line text input
 */
export const StyledTextArea = styled(TamaguiTextArea, {
  // Base styling
  backgroundColor: '$tertiary50',
  paddingHorizontal: '$4',
  paddingVertical: '$4',
  fontSize: '$1',
  borderWidth: 0,
  placeholderTextColor: '$secondary75',
  color: '$color',
  borderRadius: '$true',
  minHeight: 120,

  // Remove border and outline on focus
  focusStyle: {
    borderWidth: 0,
    outlineWidth: 0,
  },

  // Hover state
  hoverStyle: {
    backgroundColor: '$tertiary75',
  },

  // Disabled state
  disabledStyle: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
});
